import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import AOS from "aos";
import "aos/dist/aos.css";
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents)

import {
  ObserveVisibility
} from 'vue-observe-visibility';



const VueScrollTo = require('vue-scrollto');

Vue.config.productionTip = false;


/**
 * Style Files
 */

require('./assets/styles/tailwind.css');

require('./assets/styles/app.scss');
Vue.use(VueScrollTo);
// Vue.use(VueAgile);
Vue.directive('observe-visibility', ObserveVisibility);


new Vue({
  created() {
    AOS.init();
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app');